// Mock data for Es Soluções Tec Landing Page

export const companyInfo = {
  name: "Es Soluções Tec",
  slogan: "Transformando ideias em soluções digitais",
  tagline: "Tecnologia que impulsiona seu negócio",
  email: process.env.REACT_APP_COMPANY_EMAIL || "contato@essolucoestec.com.br",
  description: "Somos especialistas em desenvolvimento de software e soluções de TI para empresas de todos os portes. Com expertise em ERPs personalizados, ajudamos negócios a alcançarem todo seu potencial através da tecnologia."
};

export const services = [
  {
    id: 1,
    title: "Desenvolvimento de Software",
    description: "Criamos soluções sob medida para atender às necessidades específicas do seu negócio, desde aplicações web até sistemas complexos.",
    icon: "Code"
  },
  {
    id: 2,
    title: "Sistemas ERP",
    description: "Desenvolvemos ERPs completos e personalizados para gestão empresarial, integrando todos os processos do seu negócio.",
    icon: "Database"
  },
  {
    id: 3,
    title: "Consultoria em TI",
    description: "Oferecemos consultoria especializada para otimizar sua infraestrutura tecnológica e processos digitais.",
    icon: "Settings"
  },
  {
    id: 4,
    title: "Suporte Técnico",
    description: "Suporte dedicado para manter seus sistemas funcionando com máxima eficiência e disponibilidade.",
    icon: "Headphones"
  }
];

export const projects = [
  {
    id: 1,
    name: "SisPDV",
    description: "Sistema ERP completo de PDV para restaurantes. Gestão de vendas, estoque, comandas eletrônicas e muito mais em uma única plataforma.",
    link: "https://sispdv.com.br",
    tags: ["ERP", "PDV", "Restaurantes"],
    features: ["Gestão de Vendas", "Controle de Estoque", "Comandas Eletrônicas", "Relatórios Gerenciais"]
  },
  {
    id: 2,
    name: "ViajeJunto",
    description: "Plataforma inteligente para organização de viagens em grupo. Planeje, organize e compartilhe experiências de forma colaborativa.",
    link: "https://viajejunto.com.br",
    tags: ["Viagens", "Organização", "Colaborativo"],
    features: ["Planejamento Colaborativo", "Divisão de Custos", "Roteiros Personalizados", "Chat em Grupo"]
  },
  {
    id: 3,
    name: "TabKeeper",
    description: "Gerenciador inteligente de favoritos para organizar, categorizar e sincronizar seus links. Acesse de qualquer lugar com o app web e extensão Chrome.",
    link: "https://tabkeeper.com.br",
    tags: ["Favoritos", "Organização", "Produtividade"],
    features: ["Categorias Hierárquicas", "Tags Coloridas", "Importar/Exportar", "Extensão Chrome", "Modo Escuro", "PWA Instalável"]
  },
  {
    id: 4,
    name: "Forjadores",
    description: "Plataforma completa para gestão de células religiosas e comunidades de fé. Organize encontros, acompanhe membros e fortaleça os laços da sua igreja.",
    link: "https://forjadores.com.br",
    tags: ["Células", "Igreja", "Comunidade"],
    features: ["Gestão de Células", "Controle de Presença", "Agendamento de Encontros", "Dashboard Analítico"]
  }
];

export const aboutInfo = {
  title: "Sobre Nós",
  description: "A Es Soluções Tec nasceu da paixão por tecnologia e do desejo de transformar a forma como empresas utilizam recursos digitais. Nossa equipe é formada por profissionais experientes e comprometidos em entregar soluções de alta qualidade.",
  highlights: [
    { label: "Anos de Experiência", value: "5+" },
    { label: "Projetos Entregues", value: "50+" },
    { label: "Clientes Satisfeitos", value: "30+" }
  ]
};
